import {
  ComposedChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip,
  Line, ResponsiveContainer,
} from 'recharts';

export default function PeriodChart({ data }) {
  return (
    <div style={{ width: '100%', height: 300 }}>
      <div style={{ textAlign: 'center' }}>Uspjeh po klasif. periodima</div>
      <ResponsiveContainer>
        <ComposedChart
          width={350} height={200} data={data}
          margin={{ top: 20, right: 20, bottom: 20, left: 20 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="period" />
          <YAxis domain={[0, 5]} />
          <Tooltip />
          <Bar dataKey="prosjek" barSize={20} fill="#0c99c1" label={{ position: 'top' }} />
          <Line type="monotone" dataKey="prosjek" stroke="#ff7300" />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
}
